export default __webpack_public_path__ + "static/media/precedent.7d08e7a2.svg";